import {C} from '~/configurations/active-configuration';

/**
 * The deployment's locale (configuration `profile.locale`, the one the rest of the app formats with): every number and
 * date on the Category Profile pages follows it.
 */
export const LOCALE: string = C.profile.locale;
